/* @ngInject */
function CampaignFloatingToolBarPostsController ($rootScope, $scope, $timeout) {
  const api = {
  }

  this.getApi = () => api

  activate()

  function activate () {

  }

  $scope.attachPostActions = (selectedPost) => {
    $rootScope.$emit('campaign.change-tab-action', 'tab-7')
    /**
     * Emitido com timeout para dar tempo da tab carregar (caso não tenha sido pré-ativada antes).
     */
    $timeout(() => {
      if ($scope.action) {
        $rootScope.$emit('campaign.attach-post-actions', selectedPost)
      } else {
        $rootScope.$emit('campaign.attach-post-new-action', selectedPost)
      }

      $rootScope.$emit('campaign.select-post-floating-tool-bar', { post: null, action: null })
    }, 100)
  }

  $scope.unselectPost = () => {
    $rootScope.$emit('campaign.select-post-floating-tool-bar', { post: null, action: $scope.action })
  }
}

export { CampaignFloatingToolBarPostsController }
